export const environment = {
  production: false,
  localDevBypassAuth: true, // bypass login untuk local dev sahaja (dihantar ke window.__env.BYPASS_AUTH oleh main.ts)
};